/**
 * Legacy prompt_blocks keys (old snake_case seed). Canonical keys are UPPER_SNAKE
 * (see app/core/prompt_seed.py). Hide these in DevTeam UI; remove from DB with
 * scripts/cleanup_legacy_prompt_blocks.py --execute
 */
export const LEGACY_PROMPT_BLOCK_KEYS = new Set<string>([
  'base_teacher_rules',
  'mode_rules_free',
  'source_rules_default',
  'lesson_type_story',
  'lesson_type_rhymes',
  'lesson_type_pesuvom',
  'lesson_type_vocab_general',
  'lesson_type_body_parts',
  'communication_rules_topic',
  'final_output_check',
]);

export function isLegacyPromptBlockKey(key: string): boolean {
  return LEGACY_PROMPT_BLOCK_KEYS.has(key);
}
